export default [
    {
        path: '/',
        redirect: '/home',
    }, { //前台
        path: '/index',
        redirect: '/home',
        name: 'Index',
        component: () => import('@/views/home'),
        children:[
            { //首页
                path: '/home',
                name: 'Home',
                component: () => import('@/views/home/home'),
            },{ //新闻动态
                path: '/news',
                name: 'News',
                component: () => import('@/views/home/news'),
            }, { //政策法规
                path: '/policy',
                name: 'policy',
                component: () => import('@/views/home/policy'),
            },
            { //行业应用
                path: '/Industry',
                name: 'Industry',
                component: () => import('@/views/home/Industry'),
            },{ //申请加入
                path: '/apply',
                name: 'Apply',
                component: () => import('@/views/home/apply'),
            },{ //应用领域
                path: '/app-field',
                name: 'AppField',
                component: () => import('@/views/home/appField'),
            },{ //关于我们
                path: '/about',
                name: 'About',
                component: () => import('@/views/home/about'),
            },{ //新闻动态--详情页
                path: '/details/:id',
                name: 'Details',
                component: () => import('@/views/home/components/details'),
            }
        ]
    },{//登录
        path: '/login',
        name: 'Login',
        component: () => import('@/views/admin/login'),
    },{ //后台
        path: '/admin',
        name: 'Admin',
        redirect: '/admin/home',
        component: () => import('@/views/admin/layout/layout'),
        children:[{ //后台--首页
            path: 'home',
            name: 'AdminHome',
            component: () => import('@/views/admin/home'),
        },
            // { //后台--账号管理
            // path: 'account-manage',
            // name: 'AccountManage',
            // component: () => import('@/views/admin/account/accountManage'),
            // },
            { //后台--账号管理
                path: 'account-manage',
                name: 'AccountManage',
                component: () => import('@/views/admin/account/accountManageifno'),
            },
            { //后台--节点注册
            path: 'node-register',
            name: 'NodeRegister',
            component: () => import('@/views/admin/business/nodeRegister'),
        },{ //后台--节点管理
            path: 'node-manage',
            name: 'NodeManage',
            component: () => import('@/views/admin/business/nodeManage'),
        }]
    }
]